const style = {
  page: {
    display: "flex",
    flexDirection: "column" as "column",
  },
};

function HelpPage() {
  return <div style={style.page}></div>;
}

export default HelpPage;
